import axios from 'axios'

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_ADMIN_BASE_URL
})

export default {
  async activate (firstName, lastName, password, token) {
    try {
      const { data } = await httpClient.post(`/users/activate/${token}`, { firstName, lastName, password })
      return data
    } catch (e) {
      console.error(`Can't activate user. Error: ${e.message}`)
      throw e
    }
  }
}
